'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onChildChanged = exports.getWatchChild = exports.onChild = exports.getChild = exports.ensureIdType = exports.authUsr = exports.userEntity = exports.userFields = undefined;

var _pick2 = require('lodash/fp/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _merge2 = require('lodash/fp/merge');

var _merge3 = _interopRequireDefault(_merge2);

var _zipObject2 = require('lodash/zipObject');

var _zipObject3 = _interopRequireDefault(_zipObject2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _fill2 = require('lodash/fill');

var _fill3 = _interopRequireDefault(_fill2);

var _curry2 = require('lodash/curry');

var _curry3 = _interopRequireDefault(_curry2);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

exports.entityDb = entityDb;
exports.entityPath = entityPath;
exports.entitySet = entitySet;
exports.entityUpdate = entityUpdate;
exports.triplePut = triplePut;
exports.getValue = getValue;
exports.getDbEntity = getDbEntity;
exports.nextAction = nextAction;
exports.arrayTrueObj = arrayTrueObj;

var _capeLodash = require('cape-lodash');

var _reduxGraph = require('redux-graph');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var userFields = exports.userFields = (0, _pick3.default)(['displayName', 'email', 'emailVerified', 'isAnonymous', 'photoURL', 'uid']);
var userEntity = exports.userEntity = (0, _flow3.default)(userFields, (0, _capeLodash.rename)({
  displayName: 'name',
  photoURL: 'image',
  uid: 'id'
}), (0, _merge3.default)({
  type: 'Person'
}));
var authUsr = exports.authUsr = (0, _pick3.default)(['id', 'type']);
var ensureIdType = exports.ensureIdType = (0, _curry3.default)(function (type, item, id) {
  return item.id && item.type && item || _extends({}, item, {
    id: id,
    type: type
  });
});

function entityDb(db, item) {
  if (!item) throw new Error('2nd arg must be item object.');

  if (!item.type) {
    console.error(item);
    throw new Error('item must include type.');
  }

  if (!item.id) {
    console.error(item);
    throw new Error('item must include type.');
  }

  return db.child(item.type).child(item.id);
}

function entityPath(item) {
  var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return item.type + '/' + item.id + '/' + field;
}

function entitySet(_ref, node) {
  var entity = _ref.entity,
      TIMESTAMP = _ref.TIMESTAMP;
  var item = (0, _reduxGraph.insertFields)(node);
  item.dateCreated = TIMESTAMP;
  item.dateModified = TIMESTAMP;
  return entityDb(entity, item).set(item).then(function () {
    return item;
  });
}

function entityUpdate(_ref2, node) {
  var entity = _ref2.entity,
      TIMESTAMP = _ref2.TIMESTAMP;

  var item = _extends({}, node, {
    dateModified: TIMESTAMP
  });

  return entityDb(entity, item).update(item).then(function () {
    return item;
  });
}

function triplePut(_ref3, _ref4) {
  var _updateObj;

  var entity = _ref3.entity,
      TIMESTAMP = _ref3.TIMESTAMP;
  var payload = _ref4.payload,
      meta = _ref4.meta;
  var triple = (0, _reduxGraph.buildTriple)(payload);
  var subject = triple.subject,
      predicate = triple.predicate,
      object = triple.object;
  var path = _reduxGraph.REFS + '/' + predicate + '/' + (0, _reduxGraph.getKey)(object);
  var updateObj = (_updateObj = {}, _defineProperty(_updateObj, entityPath(subject, path), object), _defineProperty(_updateObj, entityPath(subject, 'dateModified'), TIMESTAMP), _updateObj);

  if (meta.previousSubject) {
    var prevSubj = meta.previousSubject;
    updateObj[entityPath(prevSubj, path)] = null;
    updateObj[entityPath(prevSubj, 'dateModified')] = TIMESTAMP;
  }

  return entity.update(updateObj).then(function () {
    return triple;
  });
}

function getValue(method, db, id) {
  return db.child(id)[method]('value').then(function (res) {
    return res.val();
  });
}

var getChild = exports.getChild = (0, _partial3.default)(getValue, 'once');

function getDbEntity(firebase, entity) {
  return getChild(firebase.entity.child(entity.type), entity.id);
}

var onChild = exports.onChild = (0, _curry3.default)(function (actionType, db, id, callback) {
  return db.child(id).on(actionType, function (res) {
    return callback(res.val(), res.key);
  });
});
var getWatchChild = exports.getWatchChild = onChild('value');
var onChildChanged = exports.onChildChanged = onChild('child_changed');

function nextAction(_ref5) {
  var action = _ref5.action,
      next = _ref5.next;
  return next(action);
}

function arrayTrueObj(arr) {
  if (!arr || !arr.length) return {};
  return (0, _zipObject3.default)(arr, (0, _fill3.default)(Array(arr.length), true));
}